import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import EscudoBadge from "@/components/EscudoBadge";
import FlagRibbon from "@/components/FlagRibbon";

export default function ThankYouPage() {
  // Spanish only — per requirements
  return (
    <div
      className="min-h-screen flex flex-col bg-white"
      data-testid="thankyou-page"
    >
      <header
        style={{ backgroundColor: "#0B1D3A" }}
        className="w-full"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center gap-3">
          <span className="rounded-full bg-white p-1.5">
            <EscudoBadge className="h-9 w-9" />
          </span>
          <span
            className="text-white text-xl"
            style={{ fontFamily: "Merriweather, serif", fontWeight: 700 }}
          >
            Parakox
          </span>
        </div>
        <FlagRibbon />
      </header>

      <main className="flex-1 flex items-center">
        <div className="max-w-2xl mx-auto px-6 py-24 text-center">
          <div className="mx-auto inline-flex h-16 w-16 items-center justify-center rounded-full"
               style={{ backgroundColor: "#10B981" }}>
            <CheckCircle2 className="h-9 w-9 text-white" />
          </div>
          <h1
            className="mt-6 text-4xl sm:text-5xl text-slate-900"
            style={{ fontFamily: "Merriweather, serif", fontWeight: 700 }}
            data-testid="thankyou-title"
          >
            ¡Gracias por registrarse!
          </h1>
          <p className="mt-5 text-lg text-slate-700 leading-relaxed">
            Hemos recibido correctamente sus datos. En las próximas horas
            recibirá un correo electrónico con el manual digital de
            planificación financiera 2026 y el calendario de talleres
            oficiales en Lima y regiones del Perú.
          </p>
          <p className="mt-3 text-sm text-slate-500">
            Si no encuentra nuestro mensaje, revise su carpeta de correo no deseado.
          </p>
          <Link
            to="/"
            className="mt-10 inline-flex items-center justify-center rounded-md px-6 py-3 text-white font-semibold"
            style={{ backgroundColor: "#0B1D3A" }}
            data-testid="thankyou-back-home"
          >
            Volver al inicio
          </Link>
        </div>
      </main>

      <footer
        style={{ backgroundColor: "#0B1D3A" }}
        className="text-slate-300 text-center py-6 text-xs"
      >
        <FlagRibbon className="mb-4" />
        © 2026 Parakox S.A.C. – RUC 20612345678 – San Isidro, Lima, Perú.
      </footer>
    </div>
  );
}
